import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
let {
  BASE_FONT_FAMILY,
  BUTTON_BG_COLOR,
  BUTTON_COLOR,
  BUTTON_HOVER_BG_COLOR,
  DISABLED_COLOR
} = constants;

let styles = {
  base: {
    minWidth: 75,
    fontWeight: 600,
    fontFamily: BASE_FONT_FAMILY,
    textTransform: 'uppercase',
    textAlign: 'center',
    padding: '10px 24px',
    border: 0,
    borderRadius: 7,
    backgroundColor: BUTTON_BG_COLOR,
    color: BUTTON_COLOR,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: BUTTON_HOVER_BG_COLOR
    }
  },
  disabled: {
    backgroundColor: DISABLED_COLOR,
    opacity: 0.2,
    cursor: 'normal',
    ':hover': {
      backgroundColor: DISABLED_COLOR
    }
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/inputs/button/Button.styles.js